let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5AvFX")).then(() => parcelRequire('ahD0z'));